export default "__VITE_ASSET__CRqKKCBs__"